module.exports = __webpack_public_path__ + "img/playlist-fuck.80291f2e.svg";